export const getStyle = () => ({
  container: {
    position: 'relative',

    '& button': {
      background: 'none',
      border: 'none',
    },

    '& .iconba': {
      marginLeft: 8,
    },
  },
});
